import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'react-final-form';
import {
  Accordion,
  AccordionSet,
  Button,
  Checkbox,
  Col,
  InfoPopover,
  Pane,
  PaneFooter,
  Row,
  TextField,
} from '@folio/stripes/components';
import stripesFinalForm from '@folio/stripes/final-form';

const SelfCheckoutSettingsForm = (props) => {
  const { handleSubmit, pristine, submitting, label, intl } = props;

  const supportedMessages = [
    'LOGIN',
    'SC_ACS_STATUS',
    'PATRON_INFORMATION',
    'CHECKOUT',
    'CHECKIN',
    'RENEW',
    'RENEW_ALL',
    'PATRON_STATUS_REQUEST',
    'END_PATRON_SESSION',
    'FEE_PAID',
    'ITEM_INFORMATION',
    'BLOCK_PATRON',
    'ITEM_STATUS_UPDATE',
    'PATRON_ENABLE',
    'HOLD',
    'REQUEST_SC_ACS_RESEND',
  ];

  const getFooter = () => (
    <PaneFooter
      renderEnd={
        <Button
          onClick={handleSubmit}
          disabled={pristine || submitting}
          buttonStyle="primary"
        >
          <FormattedMessage id="stripes-core.button.save" />
        </Button>
      }
    />
  );

  return (
    <Pane
      defaultWidth="fill"
      fluidContentWidth
      paneTitle={label}
      footer={getFooter()}
    >
      <form id="self-checkout-settings-form">
        <AccordionSet>
          <Accordion
            label={
              <>
                <FormattedMessage id="ui-circulation.settings.selfCheckout.generalSettings" />
                <InfoPopover
                  content={
                    <FormattedMessage id="ui-circulation.settings.selfCheckout.generalSettings.help" />
                  }
                />
              </>
            }
            id="general-settings"
            separator={false}
          >
            <Row>
              <Col xs={12}>
                <Field
                  name="statusUpdateOk"
                  component={Checkbox}
                  type="checkbox"
                  label={
                    <>
                      <FormattedMessage id="ui-circulation.settings.selfCheckout.statusUpdateOk" />
                      <InfoPopover
                        content={
                          <FormattedMessage id="ui-circulation.settings.selfCheckout.statusUpdateOk.help" />
                        }
                      />
                    </>
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Field
                  name="offlineOk"
                  component={Checkbox}
                  type="checkbox"
                  label={
                    <>
                      <FormattedMessage id="ui-circulation.settings.selfCheckout.offlineOk" />
                      <InfoPopover
                        content={
                          <FormattedMessage id="ui-circulation.settings.selfCheckout.offlineOk.help" />
                        }
                      />
                    </>
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Field
                  name="patronPasswordVerificationRequired"
                  component={Checkbox}
                  type="checkbox"
                  label={
                    <>
                      <FormattedMessage id="ui-circulation.settings.selfCheckout.patronPasswordRequired" />
                      <InfoPopover
                        content={
                          <FormattedMessage id="ui-circulation.settings.selfCheckout.patronPasswordRequired.help" />
                        }
                      />
                    </>
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Field
                  name="invalidCheckinStatuses"
                  component={TextField}
                  label={
                    <>
                      <FormattedMessage id="ui-circulation.settings.selfCheckout.invalidCheckinStatuses" />
                      <InfoPopover
                        content={
                          <FormattedMessage id="ui-circulation.settings.selfCheckout.invalidCheckinStatuses.help" />
                        }
                      />
                    </>
                  }
                  placeholder={intl.formatMessage({
                    id: 'ui-circulation.settings.selfCheckout.invalidCheckinStatuses.placeholder',
                  })}
                />
              </Col>
            </Row>
          </Accordion>

          <Accordion
            label={
              <>
                <FormattedMessage id="ui-circulation.settings.selfCheckout.supportedMessages" />
                <InfoPopover
                  content={
                    <FormattedMessage id="ui-circulation.settings.selfCheckout.supportedMessages.help" />
                  }
                />
              </>
            }
            id="supported-messages"
          >
            <Row>
              <Col xs={12}>
                {supportedMessages.map((message) => (
                  <Field
                    key={message}
                    name={`supportedMessages.${message}`}
                    component={Checkbox}
                    type="checkbox"
                    label={
                      <FormattedMessage
                        id={`ui-circulation.settings.selfCheckout.message.${message}`}
                      />
                    }
                  />
                ))}
              </Col>
            </Row>
          </Accordion>
        </AccordionSet>
      </form>
    </Pane>
  );
};

SelfCheckoutSettingsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  label: PropTypes.node,
  intl: PropTypes.object.isRequired,
};

export default stripesFinalForm({
  navigationCheck: true,
})(injectIntl(SelfCheckoutSettingsForm));
